'use strict';

var JQXTreeKeyboardSupportService = function JQXTreeKeyboardSupportService(hotkeys) {
  function addHotKeys(scope) {
    hotkeys.add({
      combo: 'ctrl+right',
      description: 'Group',
      callback: function callback() {
        scope.addToGroup();
      }
    });
    hotkeys.add({
      combo: 'ctrl+left',
      description: 'Ungroup',
      callback: function callback() {
        scope.removeFromGroup();
      }
    });
    hotkeys.add({
      combo: 'ctrl+up',
      description: 'Move Up',
      callback: function callback() {
        scope.moveUp();
      }
    });
    hotkeys.add({
      combo: 'ctrl+down',
      description: 'Move Down',
      callback: function callback() {
        scope.moveDown();
      }
    });
  }
  function removeHotKeys() {
    hotkeys.del('ctrl+right');
    hotkeys.del('ctrl+left');
    hotkeys.del('ctrl+up');
    hotkeys.del('ctrl+down');
  }
  return {
    addHotKeys: addHotKeys,
    removeHotKeys: removeHotKeys
  };
};
JQXTreeKeyboardSupportService.$inject = ['hotkeys'];
module.exports = JQXTreeKeyboardSupportService;